import { render, staticRenderFns } from "./PartnershipDashboard.vue?vue&type=template&id=2ed77526&"
import script from "./PartnershipDashboard.vue?vue&type=script&lang=js&"
export * from "./PartnershipDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports